// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Oe0HE","defContainer":"styles_defContainer__BV64N","pdfContainer":"styles_pdfContainer__aGZwp"};